import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { Tabs, Badge } from 'antd';

import uistate from '../modules/uistate';
import currentuser from '../modules/currentuser';
import reports from '../modules/reports';
import common from '../common';
import processingactivities from '../modules/processingactivities';

const { DelegatedWaitingForApprovalReportsGrid } = reports;
const { DelegatedWaitingForApprovalActivitesGrid } = processingactivities;

export function setSelectedReportsTab(key) {
    return {
        type: 'reports/SET_REPORTS_SELECTEDTAB',
        payload: key
    };
}
class DelegatedWaitingForApprovalScreen extends Component {

    label = (key) => {
        return common.getLabel(this.props.labels, 'components', 'DelegatedWaitingForApprovalScreen', key);
    }

    handleChangeActiveTab = (key) => {
        this.props.setSelectedReportsTab(key);
    }
    render() {
        const tabItems = [
            {
                key: '1',
                label: (
                    <Badge count={this.props.currentuser.counters.delegatedTasks} className="badgeCountTab">
                        <span style={{ fontWeight: 'bold' }}>{this.label("TAB_Reports").toUpperCase()}</span>
                    </Badge>
                ),
                children: <DelegatedWaitingForApprovalReportsGrid {...this.props} topOffset={68} />,
            },
            this.props.currentuser.verwerkingsRegisterEnabled && {
                key: '2',
                label: (
                    <Badge count={this.props.currentuser.counters.delegatedActivityTasks} className="badgeCountTab">
                        <span style={{ fontWeight: 'bold' }}>{this.label("TAB_Activities").toUpperCase()}</span>
                    </Badge>
                ),
                children: <DelegatedWaitingForApprovalActivitesGrid {...this.props} topOffset={68} />,
            },
        ].filter(Boolean);

        return (
            <Tabs style={{ padding: 10 }} type="card" onChange={this.handleChangeActiveTab} activeKey={this.props.selectedTab} items={tabItems} />
        );
    }
}

function mapStateToProps(state) {
    return {
        labels: uistate.selectors.uiLabels(state),
        currentuser: state[currentuser.constants.NAME],
        selectedTab: state[reports.constants.NAME].selectedTab
    };
}

export default connect(mapStateToProps,
    {
        setSelectedReportsTab
    })(DelegatedWaitingForApprovalScreen);
